import moment from 'moment';

type MeasurementAlgorithm = 'STATISTICAL_METHOD' | 'POLLING_DETECTION' | 'NOT_COMPUTED';

export interface IMachineEnergy {
  machineId: number;
  current?: number;
  voltage?: number;
  powerActive?: number;
  powerReactive?: number;
  customFields?: Record<string, any>;
  dateTimeEnergy?: string;
  dateTimeEventAcquisition: string;
  machineActualMeasurementAlgorithm: MeasurementAlgorithm;
}

export interface IMachineState {
  state: string;
  description?: string;
  code?: number;
  machineId: number;
  machineName: string;
  dateTimeState?: string;
  dateTimeEventAcquisitionISO: string;
}

export interface IMachineDailyWorks {
  job: string;
  date: string;
  time: string;
}
export interface ILabel {
  type: string;
  code: string;
  description?: string;
}
export interface IMachineFromApi {
  id: number;
  name: string;
  year: string;
  function: string;
  hasImage?: boolean;
  imageStr?: string;
  operator?: string;
  customerId: number;
  machineType: string;
  serialNumber: string;
  labels?: ILabel[];
  actualMeasurementAlgorithm?: MeasurementAlgorithm;
}

export interface IMachine {
  id: number;
  name: string;
  state?: string;
  stateDescription?: string;
  operation: string;
  power?: string;
  powerAlgorithm?: string;
}

export interface IMachineTotalJobs {
  fileName: string;
  totalTime: number;
  machineId: number;
  dateTimeWork: string;
  cutMetersAsString: string;
  totalTimeAsHHmmss: string;
  creaseMetersAsString: string;
  physicalIncoherent: boolean;
}

export interface IMachineTotals {
  count: number;
  cutMetersAsString: string;
  creaseMetersAsString: string;
  totalTimeAsHHmmss: string;
  cutMetersPlusCreaseMetersDividedByTotalTimeAsString: string;
}

export interface IDateRange {
  startDate: moment.Moment;
  endDate: moment.Moment;
}

export interface IMachineJobsFilter {
  customerId?: number;
  machineId: number;
  dateRange?: IDateRange;
  zoneId?: string;
}

export interface IMachineJobsByLabelFilter {
  customerId: number;
  dateRange?: IDateRange;
  zoneId?: string;
  labelType?: string;
  labelCode?: string;
}

export interface IMachineForSettings {
  id?: number;
  year?: string;
  image?: string;
  function: MachineFunction;
  name: string;
  customerId: number;
  machineType?: string;
  serialNumber: string;
  operator?: string;
  labels: ILabel[];
}

export interface IMachineForSettingsView extends IMachineForSettings {
  functionName?: string;
  customerName?: string;
}

export interface IMachineForSettingsView extends IMachineForSettings {
  functionName?: string;
  customerName?: string;
}

export enum MachineFunction {
  DIE_CUT = 'DIE_CUT',
  RUBBER = 'RUBBER',
  LASER = 'LASER',
  MILLING = 'MILLING',
  BRAILLE = 'BRAILLE',
}

export const functonLabel: Record<string, string> = {
  DIE_CUT: 'Bender',
  RUBBER: 'Rubber',
  LASER: 'Laser',
  MILLING: 'Milling',
  BRAILLE: 'Braille',
};
